
import React from "react";
import BlogCard from "@/components/BlogCard";
import { useBlogPosts } from "@/hooks/useBlogPosts";
import { Link } from "react-router-dom";

const BlogPreviewSection = () => {
  const { posts: latestBlogPosts, isLoading } = useBlogPosts({ 
    published: true, 
    limit: 3,
    random: true
  });

  return (
    <section className="py-16 md:py-24 bg-elfGreen-light">
      <div className="container mx-auto px-4">
        <h2 className="section-title">More Christmas ideas</h2>
        
        {isLoading ? (
          <div className="text-center py-12">
            <p className="text-lg">Loading blog posts...</p>
          </div>
        ) : latestBlogPosts.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-lg">No blog posts found. Check back soon for new content!</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
            {latestBlogPosts.map((post) => (
              <BlogCard
                key={post.id}
                title={post.title}
                excerpt={post.excerpt}
                slug={post.slug}
                imageSrc={post.featured_image || "https://images.unsplash.com/photo-1607305387299-a3d9611cd469"}
                date={new Date(post.created_at).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
              />
            ))}
          </div>
        )}
        
        <div className="text-center mt-12">
          <Link 
            to="/blog/" 
            className="btn-secondary inline-block"
          >
            Explore More Elf-Inspired Adventures!
          </Link>
        </div>
      </div>
    </section>
  );
};

export default BlogPreviewSection;
